import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Utility from '../../../../util/utilityfunctions';
import Checkbox from '../../../CoreWrappers/Checkbox';

const CheckboxItem = ({entity, onCheckChange}) => {
	const [isChecked, setIsChecked] = useState(entity.checked);
	const numberFormat = useSelector((store) => store.userPreferences.numberFormat);

	useEffect(() => {
		if (entity) {
			setIsChecked(entity.checked);
		}
	}, [entity, entity.checked]);

	const handlerOnChange = () => {
		if (entity.isEnabled) {
			setIsChecked(!isChecked);
			if (onCheckChange) onCheckChange(entity, !isChecked);
		}
	};

	const getLabel = () => {
		if (entity.isEnabled) {
			return <span className="count">{Utility.getFormattedNumber(numberFormat, entity.engagements.length)}</span>;
		}
	};

	return (
		<StyledCheckboxItem>
			<Checkbox
				className="checkBox"
				styleName="checkoption-item"
				elementStyleName={'ellipsis-one-line'}
				ellipse={false}
				noOfLines={1}
				label={entity.label}
				title={entity.label}
				statusLabel={getLabel()}
				checked={isChecked}
				disabled={!entity.isEnabled}
				onChange={handlerOnChange}
			/>
		</StyledCheckboxItem>
	);
};

const StyledCheckboxItem = styled.div`
	margin: 1rem 0;
	width: 100%;
	display: inline-flex;
	.checkoption-item {
		width: 100%;
		.motif-checkbox-label {
			width: 100%;
			color: ${(props) => props.theme.color[`grey500`]};
			.checkboxLabel {
				width: 30rem;
			}
			.statusLabel {
				margin-left: auto !important;
				font-size: 1.2rem !important;
				font-weight: normal;
				.count {
					margin-left: auto !important;
					margin: 0 !important;
					font-size: 1.2rem !important;
				}
			}
		}
		label &.motif-checkbox-disabled {
			cursor: not-allowed;
		}
		.motif-checkbox-disabled {
			span,
			input,
			.motif-checkbox-custom {
				cursor: not-allowed;
			}
		}
	}
	.motif-checkbox-label:hover {
		font-weight: normal !important;
	}
`;

CheckboxItem.propTypes = {
	entity: PropTypes.shape({
		id: PropTypes.string,
		name: PropTypes.string,
		checked: PropTypes.bool,
		isEnabled: PropTypes.bool
	}).isRequired,
	onCheckChange: PropTypes.func.isRequired
};

export default CheckboxItem;
